// extracted by mini-css-extract-plugin
export default {"textFieldContainer":"CareElementTextAreaField_textFieldContainer__vmz5+","textFieldArea":"CareElementTextAreaField_textFieldArea__2oMTO"};